/**
 * Action definitions
 * {
 *     "id": "event_app_test_fact_id",
 *     "name": "Test fact friendly name",
 *     "type": "Action",
 *     "attributes": ["body"],
 *     "destinations": ["MixPanel"]
 * }
 */

import { ACTION } from '@cvent/react-analytics';

export * from './attendeeProfileActions';
export * from './calendarEventsActions';
export * from './gamificationActions';
export * from './myEventActions';
export * from './notificationActions';
export * from './reactionsActions';
export * from './sessionActions';
export * from './sessionSurveyActions';
export * from './multilingualActions';
export * from './videoActions';
export * from './livestreamLifecycleActions';

export const test = {
  id: 'test',
  name: 'Test fact',
  type: ACTION,
  attributes: ['body'],
  destinations: ['Mixpanel', 'Analytics']
};
